import styled from '@emotion/styled';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';
import { ImageMessage, TextMessage } from 'components/Dialogue';
import ExtraMenu, { Placement } from '../MessageMenu/ExtraMenu';
import { useChatContext } from '../../contexts/ChatContext';
import { useContext, useMemo } from 'react';
import { getMetaFromSender } from '../../utils';
import { useGetTranslation } from './TextMsg';
import { DialogueModeContext } from '../DialogueModeContext.tsx';

export const ImageWithTextMsg = (props: BaseMsgProps) => {
  const { raw, msg, conversation } = props;
  const {
    isGalaxy,
    dialogRef,
    singleTransToSysLang,
    showFeedback,
    setContextMenuMessage,
    setContextMenuSingleType,
    showContextMenu,
  } = useChatContext();
  const { sysLang, getTranslation } = useGetTranslation();

  const isFaq = useContext(DialogueModeContext) === 'faq';

  const { channel } = conversation;
  const { sender } = msg;
  const {
    imageWithTextContent: { text = '', imageUrl = '' } = {},
    textContent: { translationContent } = {},
  } = raw;

  const { layout } = useMemo(() => getMetaFromSender(sender), [sender]);
  const extraMenuRender = (placement: Placement) => (
    <ExtraMenu
      uiMessage={msg}
      conversation={conversation}
      isGalaxy={isGalaxy}
      onTranslate={singleTransToSysLang}
      onFeedback={showFeedback}
      channel={channel}
      targetLanguage={sysLang}
      placement={placement}
    />
  );

  return (
    <MessageExtendComplex
      {...props}
      content={
        <MenuContainer>
          {!isFaq && layout === 'right' && extraMenuRender('left')}
          <CombineWrapper>
            <MenuContent
              layout="left"
              onContextMenu={(e) => {
                e.preventDefault();

                setContextMenuMessage(msg);
                setContextMenuSingleType('image');

                setTimeout(() => {
                  showContextMenu(e);
                });
              }}
            >
              <ImageMessage src={imageUrl} width={200} lazyScrollContainer={dialogRef?.dom} />
            </MenuContent>
            <MenuContent
              layout={layout}
              onContextMenu={(e) => {
                e.preventDefault();

                setContextMenuMessage(msg);
                setContextMenuSingleType('text');

                setTimeout(() => {
                  showContextMenu(e);
                });
              }}
            >
              <TextMessage
                layout={layout}
                content={text}
                msg={raw}
                onTranslate={singleTransToSysLang}
                translation={getTranslation(translationContent)}
              />
            </MenuContent>
          </CombineWrapper>
          {!isFaq && layout === 'left' && extraMenuRender('right')}
        </MenuContainer>
      }
    />
  );
};

const MenuContainer = styled.div`
  display: flex;
  align-items: flex-end;
  > div {
    flex: 1 0 0;
  }

  .menu-content {
    display: flex;
    flex-direction: column;
  }
  .menu-content-left {
    align-items: start;
  }
  .menu-content-right {
    align-items: end;
  }
  .hoverVisible {
    visibility: hidden;
  }
  &:hover {
    .hoverVisible {
      visibility: visible;
    }
  }
`;

const MenuContent = styled.div<{ layout: 'left' | 'right' }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ layout }) => (layout === 'right' ? 'flex-end' : 'flex-start')};
`;

const CombineWrapper = styled.div`
  padding: 8px;
  background: var(--fett-bg-panel);
  border-radius: 4px;
  > div {
    width: 200px;
  }
  > div > div {
    padding: 0;
  }
`;
